<app-gen-header-result></app-gen-header-result>
<div class="wrapper">
    <div class="content">
        <div class="resultlist">
            @if (streamData && userStream) {
                <app-generic-stream-result
                    [streamData]="streamData"
                    [userStream]="userStream"
                    [userId]="userId"
                    (isLoading)="isLoading = $event"
                >
                </app-generic-stream-result>
            }
        </div>
        <!-- <div class="connectedstreams col gap-16 w100">
            <h2>Connected Streams</h2>
            <div class="row w100 gap-32">
                @for(card of connectedStreams;track card;){
                <div class="card col justify-start align-start">
                    <div class="row w100 space-between">
                        <rr-icon class="roundicon" name="wind"></rr-icon>
                        <rr-icon
                            class="w16"
                            tone="nutral"
                            name="info"
                        ></rr-icon>
                    </div>
                    <h4 class="w100">{{ card }}</h4>
                    <rr-btn
                        type="Secondary"
                        size="Medium"
                        class="w100"
                        [disabled]="true"
                        >Coming Soon (Q4 ‘25)</rr-btn
                    >
                </div>
                }
            </div>
        </div> -->
        @if (connectedStreams && connectedStreams.length > 0) {
            <div class="col gap-8 w100">
                <h3>Next Streams</h3>
                <div class="row w100 gap-16">
                    <!-- TODO: NEEDS TO BE DYNAMIC FROM API -->
                    @for (stream of connectedStreams; track stream.id) {
                        <app-stream-info-card
                            [title]="stream.streamName"
                            [credits]="stream.credits"
                            [streamId]="stream.id"
                            [category]="stream.catName"
                            [steps]="stream.stepCount"
                            [description]="stream.description"
                            (onClick)="onStreamCardClick(stream.id)"
                        >
                        </app-stream-info-card>
                    }
                </div>
            </div>
        }
    </div>
    <div class="btnrow row">
        <rr-btn type="Secondary" size="Medium" routerLink="/home/user"
            >Save & Exit</rr-btn
        >
    </div>
</div>

<rr-spinner *ngIf="isLoading"></rr-spinner>
